{
  "accountHealth": "Account Health",
  "activeCopies": "Active Copies",
  "addFavorite": "Add Favorite",
  "affectedCoins": "Affected Coins",
  "aiAlert": "AI Alert",
  "aiArbitrageScanner": "AI Arbitrage Scanner",
  "aiCenter": "AI Center",
  "aiConfidence": "AI Confidence",
  "aiConfidenceMeter": "AI Confidence Meter",
  "aiCopyTrading": "AI Copy Trading",
  "aiFinalDecision": "AI Final Decision",
  "aiGridTrading": "AI Grid Trading",
  "aiLaunchpad": "AI Launchpad",
  "aiMarketNews": "AI Market News",
  "aiMarketScanner": "AI Market Scanner",
  "aiNews": "AI News",
  "aiPortfolioManager": "AI Portfolio Manager",
  "aiProfitCalculator": "AI Profit Calculator",
  "aiRankedTrader": "AI-Ranked Trader",
  "aiRebalance": "AI Rebalance",
  "aiRecommendation": "AI Recommendation",
  "aiRecommendations": "AI Recommendations",
  "aiResult": "AI Result",
  "aiRiskEngine": "AI Risk Engine",
  "aiRiskLevel": "AI Risk Level",
  "aiRiskManager": "AI Risk Manager",
  "aiScanResult": "AI Scan Result",
  "aiScore": "AI Score",
  "aiSignal": "AI Signal",
  "aiSmartAlerts": "AI Smart Alerts",
  "aiSubtitle": "AI-powered trading, analytics, automation and risk management.",
  "aiSuggestions": "AI Suggestions",
  "aiTitle": "Artificial Intelligence",
  "aiTrader": "AI Trader",
  "aiTradingAssistant": "AI Trading Assistant",
  "aiTradingAssistantSubtitle": "Real-time AI market signals, sentiment and trend analysis.",
  "aiTrustScore": "AI Trust Score",
  "aiWhaleAlerts": "AI Whale Alerts",
  "aiWhaleHeatmap": "AI Whale Heatmap",
  "aiWhaleTracker": "AI Whale Tracker",
  "alertType": "Alert Type",
  "allCategories": "All Categories",
  "allImpact": "All Impact",
  "allImpacts": "All Impacts",
  "allSentiments": "All Sentiments",
  "allSymbols": "All Symbols",
  "apply": "Apply",
  "applySafeModeScan": "Apply Safe-Mode Scan",
  "applying": "Applying...",
  "arbitrageOpportunities": "Arbitrage Opportunities",
  "assetAllocation": "Asset Allocation",
  "audit": "Audit",
  "backendPreviewAlerts": "Alerts are previewed here before being saved.",
  "backendWillSaveAfterApi": "This will be saved once the backend confirms the request.",
  "baseCoin": "Base Coin",
  "breaking": "Breaking",
  "btcDominance": "BTC Dominance",
  "btcVolatilityNews": "BTC Volatility News",
  "buyDecision": "Buy",
  "buyExchange": "Buy Exchange",
  "buyPressure": "Buy Pressure",
  "buyPrice": "Buy Price",
  "buySignal": "Buy",
  "buyStrength": "Buy Strength",
  "buyVolume": "Buy Volume",
  "buyZone": "Buy Zone",
  "calculate": "Calculate",
  "calculateAiProfit": "Calculate AI Profit",
  "calculating": "Calculating...",
  "capitalGreaterThanZero": "Capital must be greater than zero.",
  "capitalProtection": "Capital Protection",
  "category": "Category",
  "clear": "Clear",
  "communityScore": "Community Score",
  "compoundDays": "Compound Days",
  "compoundResult": "Compound Result",
  "condition": "Condition",
  "confidence": "Confidence",
  "confidenceScore": "Confidence Score",
  "contractSafety": "Contract Safety",
  "copyTradeIdMissing": "Copy trade ID is missing.",
  "copyTrader": "Copy Trader",
  "copyTradingStarted": "Copy trading started.",
  "copyTradingStopped": "Copy trading stopped.",
  "createAiAlert": "Create AI Alert",
  "createAiOpportunity": "Create AI Opportunity",
  "createAiWhaleAlert": "Create AI Whale Alert",
  "createGridStrategy": "Create Grid Strategy",
  "createLaunchpadProject": "Create Launchpad Project",
  "createOpportunity": "Create Opportunity",
  "createSmartAlert": "Create Smart Alert",
  "createWhaleAlert": "Create Whale Alert",
  "created": "Created",
  "creating": "Creating...",
  "currentPrice": "Current Price",
  "currentRiskScore": "Current Risk Score",
  "dailyProfit": "Daily Profit",
  "delete": "Delete",
  "deleteCalculationConfirm": "Are you sure you want to delete this calculation?",
  "deleteMarketScanConfirm": "Are you sure you want to delete this market scan?",
  "detected": "Detected",
  "diversification": "Diversification",
  "emailAlert": "Email Alert",
  "enableCompoundingProjection": "Enable Compounding Projection",
  "enterCopyAmountFor": "Enter copy amount for",
  "enterNewsTitle": "Enter news title",
  "exitPrice": "Exit Price",
  "expectedLoss": "Expected Loss",
  "expectedProfit": "Expected Profit",
  "extremeFear": "Extreme Fear",
  "extremeGreed": "Extreme Greed",
  "failedCalculateProfit": "Failed to calculate profit.",
  "failedCreateArbitrageOpportunity": "Failed to create arbitrage opportunity.",
  "failedCreateGridStrategy": "Failed to create grid strategy.",
  "failedCreateLaunchpadProject": "Failed to create launchpad project.",
  "failedCreateSmartAlert": "Failed to create smart alert.",
  "failedDeleteCalculation": "Failed to delete calculation.",
  "failedDeleteMarketScan": "Failed to delete market scan.",
  "failedLoadAiNews": "Failed to load AI news.",
  "failedLoadArbitrageScanner": "Failed to load arbitrage scanner.",
  "failedLoadGridTrading": "Failed to load grid trading.",
  "failedLoadLaunchpad": "Failed to load launchpad.",
  "failedLoadMarketScanner": "Failed to load market scanner.",
  "failedLoadProfitCalculator": "Failed to load profit calculator.",
  "failedLoadRiskManager": "Failed to load risk manager.",
  "failedLoadSmartAlerts": "Failed to load smart alerts.",
  "failedLoadTrustScore": "Failed to load trust score.",
  "failedLoadWhaleHeatmap": "Failed to load whale heatmap.",
  "failedLoadWhaleTracker": "Failed to load whale tracker.",
  "failedLogins": "Failed Logins",
  "failedMarkAlertRead": "Failed to mark alert as read.",
  "failedNewsAction": "Failed to complete this action.",
  "failedRefreshRiskProfile": "Failed to refresh risk profile.",
  "failedRunMarketScan": "Failed to run market scan.",
  "failedStartCopyTrading": "Failed to start copy trading.",
  "failedStopCopyTrading": "Failed to stop copy trading.",
  "failedSubmitNews": "Failed to submit news.",
  "failedSyncSymbol": "Failed to sync symbol.",
  "failedToLoadData": "Failed to load AI data.",
  "failedUpdateFavorite": "Failed to update favorite.",
  "favorite": "Favorite",
  "fear": "Fear",
  "fearGreedGauge": "Fear & Greed Gauge",
  "fearGreedIndex": "Fear & Greed Index",
  "featuredLaunch": "Featured Launch",
  "generate": "Generate",
  "generateAiGrid": "Generate AI Grid",
  "generating": "Generating...",
  "greed": "Greed",
  "gridCount": "Grid Count",
  "gridStrategies": "Grid Strategies",
  "grids": "Grids",
  "hardCap": "Hard Cap",
  "heat": "Heat",
  "high": "High",
  "highPriority": "High Priority",
  "highRisk": "High Risk",
  "highRiskDetected": "High risk detected.",
  "highWithdrawals": "High Withdrawals",
  "holderScore": "Holder Score",
  "impact": "Impact",
  "investment": "Investment",
  "kycCompleted": "KYC Completed",
  "lastScan": "Last Scan",
  "lastUpdated": "Last Updated",
  "latestAlert": "Latest Alert",
  "launchpadProjects": "Launchpad Projects",
  "liquidityScore": "Liquidity Score",
  "liveAiMarketSignal": "Live AI Market Signal",
  "liveVolume": "Live Volume",
  "liveWhaleAlerts": "Live Whale Alerts",
  "loading": "Loading...",
  "loadingAi": "Loading AI data...",
  "loadingAiNews": "Loading AI News...",
  "loadingArbitrageScanner": "Loading Arbitrage Scanner...",
  "loadingGridTrading": "Loading Grid Trading...",
  "loadingLaunchpad": "Loading Launchpad...",
  "loadingMarketScanner": "Loading Market Scanner...",
  "loadingProfitCalculator": "Loading Profit Calculator...",
  "loadingRiskManager": "Loading Risk Manager...",
  "loadingSmartAlerts": "Loading Smart Alerts...",
  "loadingTrustScore": "Loading Trust Score...",
  "loadingWhaleAlerts": "Loading Whale Alerts...",
  "loadingWhaleHeatmap": "Loading Whale Heatmap...",
  "loadingWhaleTracker": "Loading Whale Tracker...",
  "lowRisk": "Low Risk",
  "lowRiskDetected": "Low risk detected.",
  "lowerPrice": "Lower Price",
  "markRead": "Mark as Read",
  "marketSentiment": "Market Sentiment",
  "marketType": "Market Type",
  "marketWeaknessDetected": "Market weakness detected.",
  "maxBuy": "Max Buy",
  "medium": "Medium",
  "mediumRisk": "Medium Risk",
  "mediumRiskDetected": "Medium risk detected.",
  "minBuy": "Min Buy",
  "minimumWhaleAmountUsd": "Minimum Whale Amount (USD)",
  "moderateTrend": "Moderate Trend",
  "monthlyProfit": "Monthly Profit",
  "myCopyTrades": "My Copy Trades",
  "myMarketScanHistory": "My Market Scan History",
  "myProfitHistory": "My Profit History",
  "neutralDecision": "Neutral",
  "neutralMarketConditions": "Neutral market conditions.",
  "neutralSignal": "Neutral",
  "newsFeed": "News Feed",
  "noActiveCopyTrades": "No active copy trades.",
  "noAiNewsFound": "No AI news found.",
  "noAlertsFound": "No alerts found.",
  "noCalculationYet": "No calculation yet.",
  "noDate": "No date",
  "noGridStrategiesFound": "No grid strategies found.",
  "noHeatmapDataFound": "No heatmap data found.",
  "noLaunchpadProjectsFound": "No launchpad projects found.",
  "noOpportunitiesFound": "No opportunities found.",
  "noPinnedNews": "No pinned news.",
  "noRecommendationYet": "No recommendation yet.",
  "noRiskHistoryYet": "No risk history yet.",
  "noSavedCalculations": "No saved calculations.",
  "noSavedScans": "No saved scans.",
  "noScanYet": "No scan yet.",
  "noTrustScoresFound": "No trust scores found.",
  "noWhaleTransactionsFound": "No whale transactions found.",
  "noWhaleWalletsDetected": "No whale wallets detected.",
  "notScannedYet": "Not scanned yet.",
  "p2pDisputes": "P2P Disputes",
  "pinned": "Pinned",
  "pinnedNews": "Pinned News",
  "portfolioExposure": "Portfolio Exposure",
  "portfolioRebalancedSuccessfully": "Portfolio rebalanced successfully.",
  "position": "Position",
  "priority": "Priority",
  "processing": "Processing...",
  "projectName": "Project Name",
  "raised": "Raised",
  "raisedAmount": "Raised Amount",
  "rebalanceFailed": "Rebalance failed.",
  "records": "Records",
  "refresh": "Refresh",
  "refreshAiScan": "Refresh AI Scan",
  "risk": "Risk",
  "riskFactors": "Risk Factors",
  "riskHistory": "Risk History",
  "riskLevel": "Risk Level",
  "riskReward": "Risk / Reward",
  "riskRewardRatio": "Risk/Reward Ratio",
  "riskScore": "Risk Score",
  "roi": "ROI",
  "runAiMarketScan": "Run AI Market Scan",
  "runAiScan": "Run AI Scan",
  "safe": "Safe",
  "scan": "Scan",
  "scanning": "Scanning...",
  "searchAiNews": "Search AI news...",
  "searchWalletOrSymbol": "Search wallet or symbol...",
  "sellDecision": "Sell",
  "sellExchange": "Sell Exchange",
  "sellPressure": "Sell Pressure",
  "sellPrice": "Sell Price",
  "sellSignal": "Sell",
  "sellVolume": "Sell Volume",
  "sellZone": "Sell Zone",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "signal": "Signal",
  "signalStrength": "Signal Strength",
  "smartAlerts": "Smart Alerts",
  "softCap": "Soft Cap",
  "source": "Source",
  "sourceUrl": "Source URL",
  "spread": "Spread",
  "stop": "Stop",
  "strongBuyDecision": "Strong Buy",
  "strongBuyOpportunity": "Strong buy opportunity.",
  "strongTrend": "Strong Trend",
  "submitAiNews": "Submit AI News",
  "submitNews": "Submit News",
  "submitNewsForAiAnalysis": "Submit news for AI analysis.",
  "suggestedCopy": "Suggested Copy Amount",
  "suggestedLeverage": "Suggested Leverage",
  "summary": "Summary",
  "suspiciousActivity": "Suspicious Activity",
  "sync": "Sync",
  "syncing": "Syncing...",
  "targetPrice": "Target Price",
  "telegramAlert": "Telegram Alert",
  "timeframe": "Timeframe",
  "title": "Title",
  "titleSummaryRequired": "Title and summary are required.",
  "tokenPrice": "Token Price",
  "topGainers": "Top Gainers",
  "topGridStrategy": "Top Grid Strategy",
  "topLosers": "Top Losers",
  "topOpportunity": "Top Opportunity",
  "topWhaleWallets": "Top Whale Wallets",
  "totalAlerts": "Total Alerts",
  "totalCopied": "Total Copied",
  "totalNews": "Total News",
  "totalPL": "Total P&L",
  "totalValue": "Total Value",
  "totalWhaleVolume": "Total Whale Volume",
  "tradeSetup": "Trade Setup",
  "transferVolume": "Transfer Volume",
  "trend": "Trend",
  "trendStrength": "Trend Strength",
  "upperPrice": "Upper Price",
  "usdValue": "USD Value",
  "viewDetails": "View Details",
  "volatility": "Volatility",
  "volatilityIndex": "Volatility Index",
  "weakTrend": "Weak Trend",
  "whaleAccumulation": "Whale Accumulation",
  "whaleActivity": "Whale Activity",
  "whaleAlertCreatedFor": "Whale alert created for",
  "whaleRisk": "Whale Risk",
  "whaleScore": "Whale Score",
  "writeNewsSummary": "Write a news summary",
  "yearlyProfit": "Yearly Profit"
}